import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";
import {
  AgentInventoryConfigModel,
  AgentInventorySetting
} from "../../../agent-inventory/angular/models/inventory-setting.model";
import {$accountFactory} from "../../$account.factory";
import {AgentInventoryDialogService} from "../../../agent-inventory/angular/services/agent-inventory-dialog.service";
import {AccountsService} from "../../services/accounts-service.service";

export class DemandAccountInventoryConfigViewComponent implements IController {

  account: AccountModel;

  constructor(private accountsService: AccountsService, private agentInventoryDialogService: AgentInventoryDialogService) {

  }

  $onInit() {
    if (!this.account?.agentInventoryConfig) {
      this.account.agentInventoryConfig = {settings: []};
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

  onAddConfiguration($event) {
    const excludePackageIds = this.account.agentInventoryConfig.settings.map((s) => {
      return s.packageType;
    })
    this.agentInventoryDialogService.openAgentInventorySetting($event, undefined, excludePackageIds)
      .then((settingToCreate: AgentInventorySetting) => {
        const accountCopy = angular.copy(this.account);
        accountCopy.agentInventoryConfig.settings.push(settingToCreate);

        this._updateAccount(accountCopy);
      })
  }

  onEditSetting(setting: AgentInventorySetting, index: number) {
    const currentPackageTypes = this.account.agentInventoryConfig.settings.map((s) => {
      return s.packageType;
    })
    const excludePackageTypes = currentPackageTypes.filter((packageType) => {
      return packageType !== setting.packageType;
    })
    this.agentInventoryDialogService.openAgentInventorySetting(undefined, setting, excludePackageTypes)
      .then((updatedSetting: AgentInventorySetting) => {
        const accountCopy = angular.copy(this.account);
        accountCopy.agentInventoryConfig.settings.splice(index, 1, updatedSetting);

        this._updateAccount(accountCopy);
      })
  }

  onRemoveSetting(index: number) {
    const accountCopy = angular.copy(this.account);
    accountCopy.agentInventoryConfig.settings.splice(index, 1);

    this._updateAccount(accountCopy);
  }

  private _updateAccount(account: AccountModel) {
    this.accountsService.updateOne(account.id, account);
  }


}

angular
  .module('bringoz.admin.accounts')
  .component('demandAccountInventoryConfigView', {
    bindings: {
      account: '<'
    },
    template: require('./demand-account-inventory-config-view.html').default,
    controller: DemandAccountInventoryConfigViewComponent
  });
